import { AppRoutes } from "./routes";
export function App(){
  return <AppRoutes/>;
}

